import { PaletteColor, useTheme } from '@mui/material'
import { MainMaterialColor } from '../theme/default'

interface Props {
  size?: number
  color?: string
}

// Use https://svg2jsx.com/ to convert svg to jsx

const LoadingDots = (props: Props) => {
  const theme = useTheme()
  const { color = 'white', size = 30 } = props
  const [mainColor, secondaryColor = 'main'] = color?.split('.') || []

  const themedColor = theme.palette[mainColor as MainMaterialColor]?.[secondaryColor as keyof PaletteColor] || color
  const keySplines = '.3 0 .7 1;.3 0 .7 1'
  const duration = '1'
  const values = '65;100;65;'
  const r = 13

  return <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' width={size} height={size}>
    <circle cx='40' cy='65' r={r} fill={themedColor} stroke={themedColor} strokeWidth='15'>
      <animate
        attributeName='cy'
        begin='0'
        calcMode='spline'
        dur={duration}
        keySplines={keySplines}
        repeatCount='indefinite'
        values={values}
      ></animate>
    </circle>
    <circle cx='100' cy='65' r={r} fill={themedColor} stroke={themedColor} strokeWidth='15'>
      <animate
        attributeName='cy'
        begin='0.2'
        calcMode='spline'
        dur={duration}
        keySplines={keySplines}
        repeatCount='indefinite'
        values={values}
      ></animate>
    </circle>
    <circle cx='160' cy='65' r={r} fill={themedColor} stroke={themedColor} strokeWidth='15'>
      <animate
        attributeName='cy'
        begin='0.4'
        calcMode='spline'
        dur={duration}
        keySplines={keySplines}
        repeatCount='indefinite'
        values={values}
      ></animate>
    </circle>
  </svg>
}

export default LoadingDots
